// action types constants
export const SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT = 'SET_PAY_IN_FULL_DISABLED_FOR_REG_CHECKOUT';
export const LOAD_CHECKOUT = 'LOAD_CHECKOUT';
export const PROCESSING_STARTED = 'PROCESSING_STARTED';
export const PROCESSING_FINISHED = 'PROCESSING_FINISHED';
export const UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT = 'UPDATE_SQUAD_QTY_FOR_REG_CHECKOUT';
export const UPDATE_CART_TOTAL_FOR_REG_CHECKOUT = 'UPDATE_CART_TOTAL_FOR_REG_CHECKOUT';
export const UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT = 'UPDATE_VIRTUAL_EVENT_QTY_FOR_REG_CHECKOUT';
export const SET_ALREADY_VALIDATED = 'SET_ALREADY_VALIDATED';
export const CLEAR_PAYMENT = 'CLEAR_PAYMENT';
export const SET_TERMS_URL_FOR_REG_CHECKOUT = 'SET_TERMS_URL_FOR_REG_CHECKOUT';
export const SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT = 'SET_AGREE_TO_TERMS_FOR_REG_CHECKOUT';
export const SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT = 'SET_VALIDATION_MESSAGES_FOR_REG_CHECKOUT';
export const CREATE_CHECKOUT_PAYMENT = 'CREATE_CHECKOUT_PAYMENT';
export const SHOW_PAYMENT_DIALOG_EMBEDDED_FORM = 'SHOW_PAYMENT_DIALOG_EMBEDDED_FORM';



// WEBPACK FOOTER //
// ./src/features/registration/checkout/constants.js